import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import arrow_icon from '../../static/icons/arrow-icon-1177.png';
import { map } from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import listView from '../../static/icons/list-view.png';
import { ListView } from './ListView';
import floorPlan from '../../static/icons/floor-plan-view.png';
import { FloorPlanView } from './FloorPlanView';
import tickLogo from '../../static/icons/Check-Mark-Isolated-Icon.png';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const RoomBooking = (props) => {
  const { siteId, siteName, roomId, roomName, newBooking } = props;
  const nameRef = useRef();
  const emailRef = useRef();
  const { sites, bookingType } = props;
  const [page, setPage] = useState(!isNaN(roomId) && newBooking === false ? 10 : 0);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [disable, setDisable] = useState(true);
  const [disabledDates, setDisabledDates] = useState([]);
  const [eventObjErrors, setEventObjErrors] = useState({
    title: undefined,
    siteId: undefined,
    siteName: undefined,
    startDate: undefined,
    startTime: undefined,
    endDate: undefined,
    endTime: undefined,
    travelTime: undefined,
    invitees: undefined,
    alert: undefined,
    secondAlert: undefined,
    meetingLink: undefined,
    notes: undefined,
  });
  const [eventObj, setEventObj] = useState({
    title: '',
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    travelTime: '',
    invitees: [],
    alert: '',
    secondAlert: '',
    meetingLink: '',
    notes: '',
    isDesk: false,
    isRoom: props.isRoom,
    isOffice: props.isOffice,
  });
  const [siteIdSelected, setSiteSelected] = useState(siteId);
  const [siteNameSelected, setSiteNameSelected] = useState(siteName);
  const [roomIdSelected, setRoomIdSelected] = useState(roomId);
  const [roomNameSelected, setRoomNameSelected] = useState(roomName);
  const [eventName, setEventName] = useState('');
  const [reservationCode, setReservationCode] = useState('');
  const [reservation, setReservation] = useState();
  const [listScreen, setListScreen] = useState(false);
  const [floorPlanScreen, setFloorPlanScreen] = useState(false);
  const [modalInvitees, setModal] = useState(false);
  const history = useHistory();
  const token = localStorage.getItem('token');
  const employee = JSON.parse(localStorage.getItem('employee'));
  function onPrevClick() {
    if (page === 0 || page === 10) {
      history.go(0);
    } else if (page === 2) {
      setPage(0);
    } else if (page === 12) {
      setPage(10);
    } else {
      setPage(page - 1);
    }
  }

  useEffect(() => {
    if(roomId) {
      const response = axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/bookedDates?roomId=${roomId}`);
      response.then((res) => {
        console.log('DATES =>',res.data.dates);
        setDisabledDates(res.data.dates);
      })
    }
  },[])  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log('====================================');
    console.log('getting start Date');
    console.log('====================================');
    setStartDate(getStartDate());
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (startDate !== undefined) {
      const date = new Date(startDate);
      date.setHours(date.getHours() + 1);
      setEventObj({
        ...eventObj,
        startDate: startDate.toISOString().substring(0, 10),
        endDate: date.toISOString().substring(0, 10),
        startTime: startDate.getHours() + ':' + (startDate.getMinutes() < 10 ? '0' : '') + startDate.getMinutes(),
        endTime: date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(),
      });
      setEndDate(date);
    }
    if(siteId) {
      const site = sites.filter((site)=> site.id === siteId);
      setSiteNameSelected(site[0].name)
    }
  }, [startDate]); // eslint-disable-line react-hooks/exhaustive-deps

  const getStartDate = () => {
    const date = new Date();
    if (date.getMinutes() > 1) {
      date.setHours(date.getHours() + 1);
      date.setMinutes(0, 0, 0);
      return date;
    }
    return date;
  };

  // const getRooms = async (siteId) => {
  //   const response = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms/availableList`, {
  //     dateFrom: new Date(eventObj.startDate + ' ' + eventObj.startTime + ':00').getTime(),
  //     dateTo: new Date(eventObj.endDate + ' ' + eventObj.endTime + ':00').getTime(),
  //     isRoom: true,
  //     accountId: employee.accountId,
  //   });
  //   return response.data.rooms;
  // };

  useEffect(() => {
    if (eventObj.title === '' && bookingType !== 'Booked Private Office' && page !== 10) {
      setEventObjErrors({ ...eventObjErrors, title: 'Required' });
      return;
    }
    if ((siteIdSelected === '' || siteNameSelected === '' || siteNameSelected === 'Please select location') && page !== 10) {
      setEventObjErrors({ ...eventObjErrors, siteId: 'Required', siteName: 'Required' });
      return;
    }
    if (eventObj.startDate === '' && page !== 10) {
      setEventObjErrors({ ...eventObjErrors, startDate: 'Required' });
      return;
    }
    if (eventObj.startTime === '' && page !== 10) {
      setEventObjErrors({ ...eventObjErrors, startTime: 'Required' });
      return;
    }
    if (eventObj.endDate === '' && page !== 10) {
      setEventObjErrors({ ...eventObjErrors, endDate: 'Required' });
      return;
    }
    if (eventObj.endTime === '' && page !== 10) {
      setEventObjErrors({ ...eventObjErrors, endTime: 'Required' });
      return;
    }
    setDisable(false);
  }, [eventObj, eventName, reservationCode]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatAMPM = (date) => {
    let AMPM = '';
    let hour = '';
    let min = '';
    if (date.getHours() > 0 && date.getHours() < 12) {
      AMPM = 'am';
      hour = date.getHours();
      min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
    } else {
      AMPM = 'pm';
      hour = date.getHours() % 12 === 0 ? '12' : date.getHours() % 12;
      min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`;
    }
    return hour + ':' + min + ' ' + AMPM;
  };

  const handleSubmit = async () => {
    const bookTimeIn = eventObj.startDate + ' ' + eventObj.startTime + ':00';
    const bookTimeOut = eventObj.endDate + ' ' + eventObj.endTime + ':00';
    const { startDate, startTime, endDate, endTime, ...restObj } = eventObj;
    const response = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/add?token=${token}`, {
      name: employee['name'],
      siteName: siteNameSelected,
      company: employee['company'],
      phone: employee['phonesms'],
      email: employee['email'],
      jobTitle: employee['jobTitle'],
      isRoom: true,
      bookingType: bookingType,
      siteId: siteIdSelected,
      accountId: employee['accountId'],
      employeeId: employee['id'],
      roomId: roomIdSelected,
      roomName: roomNameSelected,
      bookedTimeIn: new Date(bookTimeIn).getTime(),
      bookedTimeOut: new Date(bookTimeOut).getTime(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...restObj,
    });
    return response.data.reservation;
  };

  useEffect(() => {
    if (page === 3) {
      handleSubmit();
      setTimeout(() => {
        history.go(0);
        history.push('/mybooking');
      }, 3000);
    }
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  function onNextClick() {
    const getReservation = async () => {
      const response = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/getReservation?token=${token}`, {
        name: eventName,
        code: reservationCode,
      });
      return response.data.reservation;
    };
    if (page === 0 && !isNaN(roomIdSelected) && newBooking) {
      handleSubmit().then((r) => {
        setReservation(r);
        setPage(11);
      });
      setTimeout(() => {
        history.go(0);
        history.push('/mybooking');
      }, 3000);
    } else if (page === 10 && (eventName !== '' || reservationCode !== '')) {
      getReservation().then((res) => {
        console.log('====================================');
        console.log('res not found =>', res);
        console.log('====================================');
        if (res) {
          setReservation(res);
          setPage(11);
        } else {
          setPage(12);
        }
      });
    } else {
      setPage(page + 1);
    }
  }
  useEffect(() => {
    if (reservation) {
      setTimeout(() => {
        const response = axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/signIn/${reservation.id}`);
        response.then((r) => {
          history.go(0);
          history.push('/mybooking');
        });
      }, 3000);
    }
  }, [reservation]); // eslint-disable-line react-hooks/exhaustive-deps

  function listScreenClicked() {
    setPage(-1);
    setListScreen(true);
    setFloorPlanScreen(false);
  }
  function floorPlanScreenClicked() {
    setPage(-1);
    setFloorPlanScreen(true);
    setListScreen(false);
  }

  console.log('values', {
    eventObj: eventObj,
    errors: eventObjErrors,
    sites: sites,
    siteIdSelected: siteIdSelected,
    roomIdSelected: roomIdSelected,
    startDate: startDate,
    endDate: endDate,
  });

  return (
    <div>
      {page === 0 ? (
        <div id={0}>
          <div className="grid-rows-1 mt-2">
            <p className="mt-60 text-center text-black text-xl">{bookingType === 'Booked Private Office' ? 'Book your Private Office' : 'Book your Meeting'}</p>
          </div>
          <div className="grid grid-rows-1 mt-5">
            <div className="grid grid-cols-1 divide-y w-full drop-shadow-xl flex justify-content-center border-2 border-grey-300 rounded-lg">
              {bookingType !== 'Booked Private Office' ? (
                <input
                  type="text"
                  id="eventTitle"
                  placeholder="Event Title"
                  className={`w-full px-2 py-2 text-black`}
                  onChange={(e) => {
                    setEventObj({ ...eventObj, title: e.target.value });
                  }}
                />
              ) : null}
              <select
                name="location"
                className={`bg-white appearance-none w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                value={siteId}
                onChange={(e) => {
                  const index = e.nativeEvent.target.selectedIndex;
                  const label = e.nativeEvent.target[index].text;
                  setSiteSelected(e.target.value);
                  setSiteNameSelected(label);
                }}
              >
                <option>Please select location</option>
                {map(sites, (site) => (
                  <option key={site.id} id={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="w-full grid grid-rows-1 mt-5 drop-shadow-xl border-2 border-grey-300 rounded-lg">
            <div className="flex grid grid-cols-1 w-full mt-5">
              <div className="grid grid-rows-1">
                <label className="text-sm text-black ml-4 flex-none">Starts</label>
              </div>
              <div className="grid grid-rows-1">
                <DatePicker
                  selected={startDate}
                  onChange={(d) => {
                    setStartDate(d);
                    setEventObj({ ...eventObj, startDate: d.toISOString().substring(0, 10) });
                  }}
                  dateFormat="MM/dd/yy"
                  className="w-5/6 flex mx-4 pr-20 mt-2 justify-center shadow  appearance-none text-black text-xs text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <DatePicker
                  selected={startDate}
                  className="w-5/6 flex mx-4 pr-20 mt-2 justify-center shadow  appearance-none text-black text-xs text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(date) => {
                    setStartDate(date);
                    setEventObj({ ...eventObj, startTime: date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() });
                  }}
                  excludeTimes={disabledDates?.map((d) => new Date(d))}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                />
              </div>
            </div>
            <div className="flex grid grid-cols-1 w-full mt-5">
              <div className="grid grid-rows-1">
                <label className="text-sm text-black ml-4 flex-none">Ends</label>
              </div>
              <div className="grid grid-rows-1">
                <DatePicker
                  selected={endDate}
                  onChange={(d) => {
                    setEndDate(d);
                    setEventObj({ ...eventObj, endDate: d.toISOString().substring(0, 10) });
                  }}
                  dateFormat="MM/dd/yy"
                  className="w-5/6 flex mx-4 pr-20 mt-2 justify-center shadow  appearance-none text-black text-xs text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <DatePicker
                  selected={endDate}
                  className="w-5/6 flex mx-4 pr-20 mt-2 justify-center shadow  appearance-none text-black text-xs text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(date) => {
                    setEndDate(date);
                    setEventObj({ ...eventObj, endTime: date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() });
                  }}
                  excludeTimes={disabledDates?.map((d) => new Date(d))}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                />
              </div>
            </div>
            <div className="w-3/6 flex justify-center w-full mt-5 mb-5">
              <label className="text-sm text-black mr-2 flex-none">Travel Time</label>
              <select
                id="travelTime"
                name="travelTime"
                defaultValue="None"
                className={`text-black w-3/6`}
                onChange={(e) => setEventObj({ ...eventObj, travelTime: e.target.value })}
              >
                <option value="None"></option>
                <option value="5 min">5 minutes</option>
                <option value="15 min">15 minutes</option>
                <option value="30 min">30 minutes</option>
                <option value="1 hr">1 hour</option>
                <option value="1 hr 30 min">1 hour 30 minutes</option>
                <option value="2 hr">2 hour</option>
              </select>
            </div>
          </div>
          {bookingType !== 'Booked Private Office' ? (
            <div className="w-full grid grid-rows-1 mt-5 drop-shadow-xl border-2 border-grey-300 rounded-lg">
              <div className={`flex justify-between w-full mx-4 mt-5 mb-5`}>
                <label className="text-sm text-black ml-2 flex-none">Invitees</label>
                <button className="flex mr-6 items-center text-gray-600" onClick={() => setModal(!modalInvitees)}>
                  {eventObj.invitees?.length === 0 ? 'None' : eventObj.invitees?.length}
                  <img className="items-end" src={arrow_icon} width="10px" alt="icon" />
                </button>
              </div>
            </div>
          ) : null}
          {modalInvitees && (
            <div id="modal" className="w-64 shadow-lg shadow-gray-100 px-5 text-black">
              <div className="w-full grid grid-cols-1 flex mt-5">
                <input
                  ref={nameRef}
                  type="text"
                  name="nameInvitee"
                  placeholder="Name"
                  className="flex-auto w-full justify-center shadow appearance-none text-black text-md pl-4 py-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <input
                  ref={emailRef}
                  type="email"
                  name="emailInvitee"
                  placeholder="Email"
                  className="flex-auto w-full justify-center shadow appearance-none text-black text-md pl-4 py-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <div className="w-full flex justify-end">
                  <button
                    className="w-6 bg-blue-500 hover:bg-blue-700 text-white font-bold my-5 rounded-full"
                    onClick={() => {
                      const name = nameRef.current.value;
                      const email = emailRef.current.value;
                      let invites = eventObj.invitees;
                      if (invites) {
                        invites.push({ name: name, email: email });
                        setEventObj({ ...eventObj, invitees: invites });
                      } else {
                        invites = [];
                        invites.push({ name: name, email: email });
                        setEventObj({ ...eventObj, invitees: invites });
                      }
                      nameRef.current.value = '';
                      emailRef.current.value = '';
                    }}
                  >
                    +
                  </button>
                </div>
                {eventObj.invitees.map((invitee) => (
                  <div key={invitee.email} className="w-full text-black text-sm my-2">
                    {invitee.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="grid grid-rows-1 mt-5">
            <div className="grid grid-cols-1 divide-y w-full drop-shadow-xl flex justify-content-center border-2 border-grey-300 rounded-lg">
              <div className="flex justify-between w-full mt-5 mb-5">
                <label className="text-sm text-black px-4 flex-none">Alert: </label>
                <select
                  id="alertTime"
                  name="alertTime"
                  defaultValue="None"
                  className={`text-black text-sm w-3/6`}
                  onChange={(e) => setEventObj({ ...eventObj, alert: e.target.value })}
                >
                  <option value="None"></option>
                  <option value="At time of event">At start of travel time</option>
                  <option value="5 min before">5 minutes before travel time</option>
                  <option value="10 min before">10 minutes before travel time</option>
                  <option value="15 min before">15 minutes before travel time</option>
                  <option value="30 min before">30 minutes before travel time</option>
                  <option value="1 hr before">1 hour before travel time</option>
                  <option value="2 hr before">2 hour before travel time</option>
                  <option value="1 day">1 day before</option>
                  <option value="2 days">2 day before</option>
                  <option value="1 week">1 week before</option>
                </select>
              </div>
              <div className="flex justify-between w-full mb-5">
                <label className="text-sm text-black px-4 mt-5 flex-none">Second Alert: </label>
                <select
                  id="secAlertTime"
                  name="secAlertTime"
                  defaultValue="None"
                  className={`text-black text-sm mt-5 w-3/6`}
                  onChange={(e) => setEventObj({ ...eventObj, secondAlert: e.target.value })}
                >
                  <option value="None"></option>
                  <option value="At time of event">At start of travel time</option>
                  <option value="5 min before">5 minutes before travel time</option>
                  <option value="10 min before">10 minutes before travel time</option>
                  <option value="15 min before">15 minutes before travel time</option>
                  <option value="30 min before">30 minutes before travel time</option>
                  <option value="1 hr before">1 hour before travel time</option>
                  <option value="2 hr before">2 hour before travel time</option>
                  <option value="1 day">1 day before</option>
                  <option value="2 days">2 day before</option>
                  <option value="1 week">1 week before</option>
                </select>
              </div>
            </div>
          </div>
          {/* <div className="w-full grid grid-rows-1 shadow-lg shadow-gray-100 bg-white-100 mt-5 rounded-full">
            <fieldset>
              <FilePicker type={'FILE'} width="w-full" {...props}>
                <span className="w-full text-black text-sm px-2 py2">Add Attachment...</span>
              </FilePicker>
            </fieldset>
          </div> */}
          <div className="grid grid-rows-1 mt-5">
            <div className="grid grid-cols-1 divide-y w-full drop-shadow-xl flex justify-content-center border-2 border-grey-300 rounded-lg">
              <input
                type="text"
                id="meetinglink"
                placeholder="Meeting Link"
                className={`w-full px-2 py-2 text-black`}
                onChange={(e) => setEventObj({ ...eventObj, meetingLink: e.target.value })}
              />
              <textarea
                rows="4"
                cols="50"
                name="notes"
                placeholder="Notes"
                className={`w-full px-2 py-2 text-black`}
                onChange={(e) => setEventObj({ ...eventObj, notes: e.target.value })}
              />
            </div>
          </div>
        </div>
      ): null}
      {page === 10 && !newBooking ? (
        <div>
          <div className="text-lg text-black text-center mt-5 mx-auto" style={{ width: '253px', height: '87px' }}>
            Enter the reservation code or the name you used for your booking.
          </div>
          <input
            type="text"
            id="eventTitle"
            placeholder="Name"
            className={`w-full px-2 py-2 text-black border-2 border-sky-500 rounded-full mt-5 focus:outline-none`}
            onChange={(e) => {
              setEventName(e.target.value);
            }}
          />
          <input
            type="text"
            id="reservationCode"
            placeholder="Reservation Code"
            className={`w-full px-2 py-2 text-black border-2 border-sky-500 rounded-full mt-5 focus:outline-none`}
            onChange={(e) => {
              setReservationCode(e.target.value);
            }}
          />
        </div>
      ): null}
      {page === 11 ? (
        <div className="flex flex-col">
          <div className="w-full text-center text-black font-black text-sm mt-10">Hi, {reservation.name}</div>
          <div className="w-full text-center text-black font-black text-sm mt-5">You are signed in</div>
          <div className="w-full text-center text-black font-black text-sm mt-10">{reservation.roomName}</div>
          <div className="w-full text-center text-black font-black text-sm mt-10 px-8">Start: {new Date(reservation.bookedTimeIn).toString()}</div>
          <div className="w-full text-center text-black font-black text-sm mt-5 px-8">To: {new Date(reservation.bookedTimeOut).toString()}</div>
          <div className="w-full text-center text-black font-black text-sm mt-10">Confirmation Code: {reservation.code}</div>
          <div className="flex flex-row justify-center mt-10">
            <img className="w-32 h-28 text-center" src={tickLogo} alt="confirm" />
          </div>
        </div>
      ): null}
      {page === 12 ? (
        <div className="flex flex-col">
          <div className="w-full text-center text-black font-black text-sm mt-10">I'm sorry, {employee['name']}</div>
          <div className="w-full text-center text-black font-black text-sm px-16">We don't have a confirmation for you.</div>
          <div className="w-full text-center text-black font-black text-sm mt-40 px-2">Would you like to book this hot desk now or later?</div>
          <div className="flex flex-row justify-around mt-40">
            <button
              onClick={() => {
                setPage(0);
              }}
              id={'buttonPrev'}
              className="inline-block py-auto px-2 rounded-full justify-center mt-2 text-center cursor-pointer left-0 font-bold"
              style={{ backgroundColor: '#51D1FA', width: '103px', height: '31px' }}
            >
              Book Now
            </button>
            <button
              onClick={() => {
                setPage(0);
              }}
              disabled={disable}
              id={'buttonNext'}
              className={`inline-block py-auto px-2 rounded-full justify-center inline-block m mt-2 text-center text-white cursor-pointer right-0 font-bold`}
              style={{ backgroundColor: '#51D1FA', width: '103px', height: '31px' }}
            >
              Book Later
            </button>
          </div>
        </div>
      ): null}
      {page === 1 ? (
        <div id={1}>
          <div className="text-sm text-center text-black font-semibold mt-20">How do you want to select your desk or meeting room?</div>
          <div onClick={listScreenClicked} className="flex w-60 h-11 bg-white shadow-lg shadow-black-500/40 mt-10">
            <div className="flex justify-start py-4">
              <img className="ml-4" src={listView} alt="list-view" />
              <span className="text-black grid grid-cols-1 content-center ml-4">List View</span>
            </div>
          </div>
          <div onClick={floorPlanScreenClicked} className="flex w-60 h-11 bg-white shadow-lg shadow-black-500/40 mt-5">
            <div className="flex justify-start py-4">
              <img className="ml-4" src={floorPlan} alt="list-view" />
              <span className="text-black grid grid-cols-1 content-center ml-4">Floor Plan View</span>
            </div>
          </div>
          <p className="text-center text-black text-xs mt-40">Powered by MyLobby.co</p>
        </div>
      ): null}
      {listScreen === true ? (
        <div>
          <ListView
            setRoomIdSelected={setRoomIdSelected}
            setRoomNameSelected={setRoomNameSelected}
            setPage={setPage}
            setListScreen={setListScreen}
            floorPlanScreenClicked={floorPlanScreenClicked}
            dateFrom={eventObj.startDate + ' ' + eventObj.startTime + ':00'}
            dateTo={eventObj.endDate + ' ' + eventObj.endTime + ':00'}
            isRoom={bookingType === 'Booked Private Office' ? false : true}
            isOffice={bookingType === 'Booked Private Office' ? true : false}
          />
        </div>
      ) : null}
      {floorPlanScreen === true ? (
        <div>
          <FloorPlanView
            setRoomIdSelected={setRoomIdSelected}
            setRoomNameSelected={setRoomNameSelected}
            setPage={setPage}
            setFloorPlanScreen={setFloorPlanScreen}
            listScreenClicked={listScreenClicked}
            dateFrom={eventObj.startDate + ' ' + eventObj.startTime + ':00'}
            dateTo={eventObj.endDate + ' ' + eventObj.endTime + ':00'}
            isRoom={bookingType === 'Booked Private Office' ? false : true}
            isOffice={bookingType === 'Booked Private Office' ? true : false}
          />
        </div>
      ) : null}
      {page === 2 ? (
        <div id={2}>
          <div className="grid-rows-1 mt-10 flex justify-center">
            <p className="text-center text-black text-xl">{employee['name']},</p>
          </div>
          <div className="grid-rows-1 mt-20">
            <p className="mt-60 text-center text-black text-xl">You have selected the {roomNameSelected}</p>
          </div>
          <div className="grid-rows-1 mt-10 flex justify-center">
            <p className="text-center text-black text-xl">Start: {eventObj.startDate.toString() + ' ' + formatAMPM(startDate)}</p>
          </div>
          <div className="grid-rows-1 mt-10 flex justify-center">
            <p className="text-center text-black text-xl">To: {eventObj.endDate.toString() + ' ' + formatAMPM(endDate)}</p>
          </div>
        </div>
      ): null}
      {page === 3 ? (
        <div id={3}>
          <div className="grid-rows-1 mt-10">
            <p className="mt-60 text-center text-black text-xl">
              {employee['name']}, you are now booked for {roomNameSelected}
            </p>
          </div>
          <div className="grid-rows-1 mt-10 flex justify-center">
            <p className="text-center text-black text-xl">From {eventObj.startDate.toString() + ' ' + formatAMPM(startDate)}</p>
          </div>
          <div className="grid-rows-1 mt-5 flex justify-center">
            <p className="text-center text-black text-xl">To {eventObj.endDate.toString() + ' ' + formatAMPM(endDate)}</p>
          </div>
          <div className="grid-rows-1 mt-10 flex justify-center">
            <img className="w-28 h-28 object-center" src={tickLogo} alt="confirm" />
          </div>
        </div>
      ): null}
      {page !== 1 && page !== -1 ? (
        <div className={`grid-rows-1 mt-10 mb-12 flex justify-between ml-5`}>
          {page < 3 || page === 10 ? (
            <button
              onClick={onPrevClick}
              id={'buttonPrev'}
              className="inline-block py-auto px-6 rounded justify-center mt-2 text-center cursor-pointer left-0 font-bold"
              style={{ backgroundColor: '#5C7CCF', width: '103px', height: '31px' }}
            >
              {page === 2 ? 'Modify' : 'Prev'}
            </button>
          ) : null}
          {page < 3 || page === 10 ? (
            <button
              onClick={onNextClick}
              disabled={disable}
              id={'buttonNext'}
              className={`inline-block py-auto px-6 rounded justify-center inline-block m mt-2 text-center ${
                disable ? `text-gray-600` : `text-white`
              } cursor-pointer right-0 font-bold`}
              style={{ backgroundColor: '#5C7CCF', width: '103px', height: '31px' }}
            >
              {page === 2 ? 'Confirm' : 'Next'}
            </button>
          ) : null}
        </div>
      ): null}
      {page !== 1 && !listScreen ? <p className={`text-center text-black text-xs ${page === 3 ? 'mt-5' : 'mt-10'} mb-20`}>Powered by MyLobby.co</p> : null}
    </div>
  );
};
